import Color from '../Color.mjs'
import superMeta from '../_PRODUCT/metaProductNode.mjs'

export default {
    ...superMeta,
    themeColor: Color.GREEN_YELLOW,
    archName: '程序地图',
    archUrl: '/ProjectFcMap',
    codeProp: 'ssUserCode',
    detailIdProp: 'ssId',
    detailUrl: '/SsDetail',
    listUrl: '/SsList',
    mapProp: 'ssMap',
    name: '子系统',
    textProp: 'ssName',
    type: 'SS',
}
